import React from 'react';
import styled from 'styled-components';
import Svg from 'components/UI/Svg/Svg';
import { red, foreColor, primaryHue2 } from 'modules/styles/colors';
import { MuiGrid } from 'theme/material-ui';

interface Props {
  text: string;
}

export default ({ text }: Props) => (
  <StyledContainer container>
    <MuiGrid item>
      <Svg name="Ambulance" height="75" width="75" fill={red} />
    </MuiGrid>
    <EmergencyText item>{text}</EmergencyText>
  </StyledContainer>
);

const StyledContainer = styled(MuiGrid)`
  background: ${foreColor};
  width: 100%;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 10px;
`;

const EmergencyText = styled(MuiGrid)`
  color: ${primaryHue2};
  margin-bottom: 10px;
  padding: 5px;
  width: 70%;
`;
